module.exports = __webpack_public_path__ + "media/customizations/ranchlife/back-colored-17c2fd5f8d19cc1ae7eecba7cc6b0ea2.jpg";